export const NOTIFICATION_TYPES = {
  COMMENT: "COMMENT",
  FOLLOW: "FOLLOW",
  LIKE: "LIKE",
  MESSAGE: "MESSAGE",
} as const;
